module.exports = {
	"Announcement": {
		"Know More": "了解更多"
	},
	"Appointment": {
		"Conditions": "点击“确定”，表示您确认已经阅读隐私政策，并同意%(brand)s在遵守隐私政策条款的前提下处理您的个人信息，以回应您的请求。",
		"Confirmation": "我们已收到您的精品店预约请求并联系一名顾问，以为您提供个人协助服务。您将收到一封确认邮件。",
		"Description": "Dior迪奥诚邀您与顾问预约并莅临精品店以获得个人服务。",
		"Get an appointment": "预约",
		"Motives": "目的",
		"Universes": "主题世界"
	},
	"DiorMap": {
		"Search in this area": "于此区域搜索"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s 结果",
			"other": "%(count)s 结果",
			"zero": "%(count)s 结果"
		},
		"Refine": "筛选",
		"RefineAria": "使用下方勾选框细化搜索范围",
		"Are you looking for?": "您是否正在寻找女装、男装、童装、珠宝或腕表精品店？"
	},
	"Footer": {
		"Download the applications": "下载应用程序",
		"Language": "语言",
		"Newsletter": "如：Christian@dior.fr",
		"Ok": "确定",
		"Subscribe to newsletter": "订阅Dior迪奥最新资讯"
	},
	"Form": {
		"All fields are mandatory": "所有栏目均为必填项",
		"Civility": "称谓",
		"Comments": "正文",
		"Conditions": "您若希望收到由%(brand)s发送的确认邮件，请勾选上方空格。您拥有存取、修改、删除和反对使用与您相关的个人信息的权利，并可以向“contact@dior.com”发送邮件以行使该权利。",
		"Date": "期望日期 ",
		"Email": "电邮",
		"Hour": "期望时段",
		"Invalid E-mail address": "无效的邮件地址",
		"Mr": "先生",
		"Mrs": "女士",
		"Name": "姓氏",
		"Phone": "电话",
		"Required fields": "必填字段",
		"Submit": "确定",
		"Surname": "名字"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "您所在城市的Dior精品店：高级成衣，香氛，皮具",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "抵达",
		"Departure": "离开",
		"Details": "详情",
		"Error": "十分抱歉，我们未能取得所查询的有关路线，请修改出发地址及／或选用的交通并重新尝试。",
		"Follow the itinerary": "跟进路线",
		"Itinerary": "路线",
		"modeBICYCLING": "切换至骑自行车",
		"modeDRIVING": "切换至驾车",
		"modeTRANSIT": "切换至搭乘公共交通工具",
		"modeWALKING": "切换至步行",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "请在纵向模式下使用您的手机"
	},
	"NavMobile": {
		"Home": "首页"
	},
	"Newsletter": {
		"Dior Newsletter": "Dior迪奥最新资讯",
		"Fashion and accessories": "时装及配饰",
		"I wish to receive the %(newsletter)s newsletter": "我希望接收关于%(newsletter)s的最新资讯",
		"Newsletter Confirmation": "您已订阅Dior迪奥最新资讯",
		"Perfume and beauty": "香氛及美妆",
		"Receive our newsletter": "接收Dior迪奥最新资讯",
		"Your universes": "您的空间"
	},
	"ResultsBlock": {
		"Dior boutiques": "Dior迪奥精品店",
		"Too far": "结果过多，请缩小搜索范围以优化搜索结果。",
		"No result": "找不到店铺",
		"Other shops": "其他精品店",
		"Results": "搜索结果",
		"Fewer results, zoom in": "更少结果, zoom in",
		"More results, zoom out": "更多结果, zoom out",
		"Fewer results": "更少结果",
		"More results": "更多结果"
	},
	"SearchBlock": {
		"Geolocation": "使用地理位置寻找附近的店铺",
		"Search": "搜索"
	},
	"Share": {
		"Conditions": "您若希望收到由%(brand)s发送的确认邮件，请勾选上方空格。您拥有存取、修改、删除和反对使用与您相关的个人信息的权利，并可以向“contact@dior.com”发送邮件以行使该权利。",
		"Recipient": "您的收件人",
		"Share Confirmation": "您的精品店信息表已成功发送",
		"Share this shop": "分享精品店信息",
		"Your favorite shop": "您所选的精品店"
	},
	"ShopBlock": {
		"Closed": "营业时间已过",
		"Closed today": "今天休息",
		"Directions": "路线",
		"DirectionsAria": "前往%(shopName)s的路线",
		"Make an appointment": "预约",
		"Open": "营业",
		"Opening time": "营业时间",
		"OpeningAria": "更多有关营业时间的信息",
		"ResultNumber": "结果编号%(number)s",
		"Services": "服务",
		"ServicesAria": "更多有关服务的信息",
		"Share": "分享",
		"Special hours": "Special hours",
		"Today until %(hour)s": "今天至 %(hour)s",
		"Universes": "主题世界",
		"UniversesAria": "更多有关Dior迪奥世界的信息",
		"and": "and",
		"from": "from",
		"publicHolidays": "精品店营业时间可能已过",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/zh_cn/translations.json
// module id = 874
// module chunks = 0